import Product from '@Components/Product/Product'
import { ICommonProduct, MCommonProduct } from '@Models/common.model'
import React, { useEffect, useState } from 'react'

interface IProductBuying {
    data: MCommonProduct[]
    productActions: (products: MCommonProduct[]) => void
    calculatedProducts: MCommonProduct[]
    productType: string
}

function ProductBuying(props: IProductBuying) {
    // core section
    const { data, productActions, calculatedProducts, productType } = props
    const [products, setProducts] = useState<MCommonProduct[]>([])

    useEffect(() => {
        const filteredProducts = data?.map((product: MCommonProduct) => {
            return new MCommonProduct({
                ...product,
                checked: product?.itemSubscription?.status === 'PENDING',
            })
        })
        setProducts(filteredProducts)
        return () => {
            setProducts([])
        }
    }, [data])

    const handleFirearmActions = (
        action: string,
        product: ICommonProduct | undefined
    ) => {
        if (action === 'checkbox' && product) {
            const mappedProducts: any = products?.map(
                (item: MCommonProduct) => {
                    return {
                        ...item,
                        checked:
                            product?.id === item?.id
                                ? !product?.checked
                                : item?.checked,
                    }
                }
            )
            setProducts(mappedProducts)
        }
    }

    useEffect(() => {
        productActions(products?.length ? products : [])
    }, [products])

    // main
    return (
        <>
            {products?.length ? (
                products?.map((item: ICommonProduct, index: number) => {
                    const calculatedProduct = calculatedProducts
                        ?.filter(
                            (product: MCommonProduct) =>
                                product?.type === productType
                        )
                        ?.find(
                            (product: MCommonProduct) =>
                                product?.id === item?.id
                        )
                    return (
                        <React.Fragment
                            key={`${item.serialCode}_product_buying${+index}`}
                        >
                            <Product
                                product={calculatedProduct || item}
                                balance={false}
                                getActions={handleFirearmActions}
                                checkbox={item?.checkbox}
                                checked={item?.checked}
                                totalAmount
                                productType={
                                    productType === 'PART' ? 'PART' : undefined
                                }
                            />
                        </React.Fragment>
                    )
                })
            ) : (
                <div className="text-center mb-4">No data</div>
            )}
        </>
    )
}

export default ProductBuying
